export default "__VITE_ASSET__iP8LQbNg__"